import React, { useEffect, useState } from 'react';
import classnames from 'classnames';
import UserMenu from '../UserMenu/UserMenu';
import MainNav from '../MainNav/MainNav';
import UtilityMenu from '../UtilityMenu/UtilityMenu';
import SearchBox from '../SearchBox/SearchBox';

const Header = ({
  logoLinkUrl,
  logoSrc,
  logoAlt,
  loginUrl,
  mainNav,
  mainNavId,
  headerLinks,
  langLinks,
  regionLinks,
  memberLinks,
  user,
  newsLink,
  searchResultsEndpoint,
  searchParams,
  searchSuggestEndpoint,
}) => {
  const [isMenuExpanded, setIsMenuExpanded] = useState(false);
  const [isSearchExpanded, setIsSearchExpanded] = useState(false);

  const headerClasses = classnames('header', {
    active: isMenuExpanded,
  });
  const menuBtnClasses = classnames('header__btn', {
    'header__btn--menu': !isMenuExpanded,
    'header__btn--close': isMenuExpanded,
  });
  const searchBtnClasses = classnames('header__btn', {
    'header__btn--search': !isSearchExpanded,
    'header__btn--close': isSearchExpanded,
  });
  const loginWrapperClasses = classnames('header__login-wrapper', {
    active: isMenuExpanded,
  });
  const navWrapperClasses = classnames('header__nav-wrapper', {
    active: isMenuExpanded,
  });
  const linksWrapperClasses = classnames('header__links-wrapper', {
    active: isMenuExpanded,
  });
  const searchWrapperClasses = classnames('header__search-wrapper', {
    active: isSearchExpanded,
  });

  const toggleMenu = () => {
    if (isMenuExpanded) {
      setIsMenuExpanded(false);
    } else {
      setIsMenuExpanded(true);
      setIsSearchExpanded(false);
    }
  };

  const toggleSearch = () => {
    if (isSearchExpanded) {
      setIsSearchExpanded(false);
    } else {
      setIsSearchExpanded(true);
      setIsMenuExpanded(false);
    }
  };

  const handleKeyDown = (evt) => {
    if (evt.key === 'Escape') {
      setIsMenuExpanded(false);
      setIsSearchExpanded(false);
    }
  };

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    // Remove event listener on cleanup
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, []); // Empty array ensures that effect is only run on mount and unmount

  return (
    <div className={headerClasses}>
      <a href={logoLinkUrl} className="header__logo-link">
        <img className="header__logo-img" src={logoSrc} alt={logoAlt} />
      </a>
      <div className={navWrapperClasses}>
        <MainNav mainNav={mainNav} id={mainNavId} />
      </div>
      <div className="header__btn-wrapper">
        <button className={menuBtnClasses} onClick={toggleMenu}>
          <span className="visuallyhidden">Menu</span>
        </button>
        <button className={searchBtnClasses} onClick={toggleSearch}>
          <span className="visuallyhidden">Search</span>
        </button>
      </div>
      <div className={searchWrapperClasses}>
        <SearchBox
          searchResultsEndpoint={searchResultsEndpoint}
          searchParams={searchParams}
          searchSuggestEndpoint={searchSuggestEndpoint}
          isHeaderSearch={true}
          heading="What are you looking for?"
        />
      </div>
      <div className={linksWrapperClasses}>
        <UtilityMenu
          headerLinks={headerLinks}
          langLinks={langLinks}
          regionLinks={regionLinks}
        />
      </div>
      <div className={loginWrapperClasses}>
        <UserMenu
          loginUrl={loginUrl}
          memberLinks={memberLinks}
          user={user}
          newsLink={newsLink}
        />
      </div>
      <div className="header__divider"></div>
    </div>
  );
};

export default Header;
